import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getImageUrl } from "../../utils/imageUtils";

// Private documents and photos are served through signed links that stop working after a few
// hours. If one fails to load, SignedImage asks SignedMediaProvider (once per URL) to reload the
// data that holds it, which brings a fresh link.

// Defaults to a no-op so images still render outside the provider (e.g. in tests)
export const SignedMediaContext = createContext(() => {});

export function SignedImage({ src, onError, ...props }) {
  const refresh = useContext(SignedMediaContext);
  const [retried, setRetried] = useState(false);

  // A refresh gives a new signed URL, which gets its own retry
  useEffect(() => setRetried(false), [src]);

  const handleError = (event) => {
    if (!retried) {
      setRetried(true);
      refresh();
    }
    if (onError) onError(event);
  };

  return <img src={getImageUrl(src)} onError={handleError} {...props} />;
}

SignedImage.propTypes = {
  src: PropTypes.string,
  onError: PropTypes.func,
};
